/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createJobResponseFromDiscriminatorValue, serializeCreateDynamicWatermarkJobRequest, serializeJobResponse, type CreateDynamicWatermarkJobRequest, type HttpValidationProblemDetails, type IError, type JobResponse } from '../../models/index.js';
// @ts-ignore
import { IdentifyRequestBuilderRequestsMetadata, type IdentifyRequestBuilder } from './identify/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /jobs/dynamic-watermark
 */
export interface DynamicWatermarkRequestBuilder extends BaseRequestBuilder<DynamicWatermarkRequestBuilder> {
    /**
     * The identify property
     */
    get identify(): IdentifyRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     post(body: CreateDynamicWatermarkJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateDynamicWatermarkJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DynamicWatermarkRequestBuilderUriTemplate = "{+baseurl}/jobs/dynamic-watermark";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DynamicWatermarkRequestBuilderNavigationMetadata: Record<Exclude<keyof DynamicWatermarkRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    identify: {
        requestsMetadata: IdentifyRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const DynamicWatermarkRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DynamicWatermarkRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateDynamicWatermarkJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
